import { render, staticRenderFns } from "./PinCreate.vue?vue&type=template&id=b9ad5f34&scoped=true&"
import script from "./PinCreate.vue?vue&type=script&lang=js&"
export * from "./PinCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ad5f34",
  null
  
)

export default component.exports